import { SigLabel } from '../components/atelier';

export function Output() {
  return (
    <section id="output" className="container section">
      <div className="block-head">
        <div>
          <SigLabel>What you get</SigLabel>
          <h2>
            A real script. <em>Real parameters.</em> A real STEP.
          </h2>
        </div>
        <p className="lede">
          Nothing throwaway. Everything LMcad produces is something you can
          open, edit, version, diff, and round-trip into your CAD.
        </p>
      </div>

      <div className="duo">
        <div className="duo-card">
          <h3>
            A parametric <em>spec, not a mesh.</em>
          </h3>
          <p>
            Every part lands as a named-parameter spec. Dimensions, materials,
            features, all surfaced. Edit the spec in chat or via the panel and
            the geometry rebuilds. No throwaway triangles.
          </p>
          <pre className="code-block" aria-hidden>
{`PART · `}<span className="kw">bracket</span>{`
─────────────────────────────────
`}<span className="com">{`# named parameters`}</span>{`
length          `}<span className="num">50.0</span>{`     mm
mount_pitch     `}<span className="num">40.0</span>{`     mm
hole_dia        `}<span className="num">6.5</span>{`      mm
fillet          `}<span className="num">2.0</span>{`      mm
material        `}<span className="str">{`steel`}</span>{`

`}<span className="com">{`# outputs`}</span>{`
→ bracket.step       `}<span className="kw">download</span>{`
→ bracket.png        `}<span className="kw">preview</span>{`
→ bracket.stl        `}<span className="kw">print-ready</span>{`
─────────────────────────────────
`}<span className="com">{`status: ready · STEP available`}</span>
          </pre>
        </div>

        <div className="duo-card">
          <h3>
            Named parameters, <em>live.</em>
          </h3>
          <p>
            Surface every dimension as a knob. Drag a slider or type a value,
            and the part rebuilds in seconds. Want a different shape instead
            of a different size? Re-prompt. The chat picks up the spec, not
            the geometry.
          </p>
          <div className="params-demo">
            <div className="row">
              <span>length</span>
              <span className="v">
                50.0<span className="u">mm</span>
              </span>
            </div>
            <div className="row">
              <span>mount_pitch</span>
              <span className="v">
                40.0<span className="u">mm</span>
              </span>
            </div>
            <div className="row">
              <span>hole_dia</span>
              <span className="v">
                6.5<span className="u">mm</span>
              </span>
            </div>
            <div className="row">
              <span>fillet</span>
              <span className="v">
                2.0<span className="u">mm</span>
              </span>
            </div>
            <div className="row">
              <span>thickness</span>
              <span className="v">
                3.0<span className="u">mm</span>
              </span>
            </div>
            <div className="row">
              <span>finish</span>
              <span className="v">anodised</span>
            </div>
            <div className="row">
              <span>material</span>
              <span className="v">6061-T6</span>
            </div>
          </div>
          <p
            className="muted"
            style={{ marginTop: 'auto', fontSize: 12, lineHeight: 1.55 }}
          >
            Iteration is part of the work. One credit per LLM call —
            first draft and re-prompts cost a credit; slider tweaks are
            free, because they&rsquo;re just value changes in the
            parametric model.
          </p>
        </div>
      </div>
    </section>
  );
}
